import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { ActionsDesktop, Container } from './header-signin.styles';
import { ReactComponent as LoginIcon } from '../../../assets/login-icon.svg';
import { useStore } from '../../../stores/store';
import { HeaderBtn } from '../header-btn/header-btn.styles';
import Button from '../../../common/button/button.component';
import { useStartParcelCreation } from '../../../hooks/use-start-parcel-creation.hook';
import { testIds } from '../../../../test-ids';
import { useIsMobile } from '../../../hooks/use-is-mobile.hook';
import { generateMyRoute } from '../../../utils/uri/uri.utils';
import { AppRoute } from '../../../constants/route';

interface Props {
  isMainPage: boolean;
}

const HeaderSignin = ({ isMainPage }: Props) => {
  const {
    commonStore: { analyticsManager, setIsGuestParcelCreation },
    userStore: { loginGup },
  } = useStore();

  const auth = useAuth();

  const isMobile = useIsMobile();

  const { t } = useTranslation();
  const handleStartParcelCreation = useStartParcelCreation();

  const handleCreateParcel = () => {
    analyticsManager.track('start_new_delivery');
    setIsGuestParcelCreation(true);
    handleStartParcelCreation();
  };

  return (
    <Container>
      {isMobile && (
        <HeaderBtn
          data-testid={testIds.header.login}
          onClick={() =>
            loginGup({
              auth,
              redirectUri: generateMyRoute(AppRoute.PARCEL_LIST),
            })
          }>
          <LoginIcon />
        </HeaderBtn>
      )}
      {!isMobile && (
        <ActionsDesktop>
          {isMainPage && (
            <Button
              testId={testIds.header.newParcel}
              fullWidth={false}
              onClick={handleCreateParcel}>
              {t('create_parcel')}
            </Button>
          )}
          <Button
            fullWidth={false}
            testId={testIds.header.login}
            appearance='secondary'
            onClick={() =>
              loginGup({
                auth,
                redirectUri: generateMyRoute(AppRoute.PARCEL_LIST),
              })
            }>
            {t('login')}
          </Button>
        </ActionsDesktop>
      )}
    </Container>
  );
};

export default HeaderSignin;
